export type FaqItem = {
  category: string;
  question: string;
  answer: string;
};

export const faqs: FaqItem[] = [
  {
    category: "Compte",
    question: "Comment créer un compte Pharmapp pour mon entreprise ?",
    answer:
      "Depuis la page d'accueil, cliquez sur Commencer maintenant puis renseignez les informations principales de votre entreprise, votre identité et vos coordonnées utiles. Une fois le compte validé, vous accédez à l'espace de mise en route.",
  },
  {
    category: "Installation",
    question: "Sur quels appareils puis-je utiliser Pharmapp ?",
    answer:
      "Pharmapp est pensé pour un usage sur appareil Android, notamment sur téléphone et terminal POS compatible. Certaines fonctions d'accès et de suivi peuvent également être consultées via le portail web selon votre formule et vos droits.",
  },
  {
    category: "Disponibilité",
    question: "Dans quels pays Pharmapp est-il disponible actuellement ?",
    answer:
      "Pour le moment, Pharmapp est disponible en République démocratique du Congo. Le déploiement vers d'autres territoires est en préparation et sera ouvert progressivement selon l'avancement du service.",
  },
  {
    category: "Essai",
    question: "Comment fonctionne l'essai gratuit ?",
    answer:
      "L'essai gratuit vous permet de découvrir la solution dans un cadre réel avant toute souscription payante. Sa durée dépend de l'offre mise en avant au moment de l'inscription et commence à la date d'activation de votre espace.",
  },
  {
    category: "Paiement",
    question: "Quand un abonnement devient-il effectif ?",
    answer:
      "L'abonnement devient effectif à la confirmation du paiement et à l'activation de la formule correspondante par Pharmapp. En cas de vérification complémentaire ou d'incident de paiement, l'activation peut être différée jusqu'à régularisation.",
  },
  {
    category: "Multi-pharmacie",
    question: "Pour gérer plusieurs pharmacies, faut-il obligatoirement prendre l'abonnement à vie ?",
    answer:
      "Non. Il est possible d'ouvrir plusieurs succursales avec des abonnements Pro ou Business distincts, en souscrivant une formule pour chaque succursale créée. L'abonnement à vie permet quant à lui de créer des succursales de manière illimitée.",
  },
  {
    category: "Données",
    question: "Mes données sont-elles conservées si la connexion Internet est faible ?",
    answer:
      "La solution est conçue pour maintenir la continuité d'exploitation grâce à une base locale et à une synchronisation ultérieure lorsque la connexion redevient disponible. Cela suppose néanmoins une utilisation normale de l'application et du matériel compatible.",
  },
  {
    category: "Scanner",
    question: "Le scanner reconnaît-il uniquement les codes-barres classiques ?",
    answer:
      "Non. Le module de scan prend en charge plusieurs formats, notamment les QR codes et différents codes-barres utilisés dans les environnements de vente. La disponibilité exacte dépend du matériel, des autorisations caméra et du contexte d'utilisation sur l'appareil concerné.",
  },
  {
    category: "Scanner",
    question: "Peut-on allumer la torche ou changer de caméra pendant le scan ?",
    answer:
      "Oui, lorsque l'appareil le permet. Pharmapp peut exploiter la torche et basculer entre plusieurs caméras disponibles afin de faciliter le scan dans des conditions de lumière ou de position moins favorables.",
  },
  {
    category: "Produits",
    question: "Peut-on retrouver l'emplacement physique d'un produit dans la pharmacie ?",
    answer:
      "Oui. Lorsqu'ils sont renseignés, l'étagère, la colonne et la ligne d'un produit peuvent être affichées pour aider l'équipe à retrouver rapidement l'article au comptoir ou en réserve.",
  },
  {
    category: "Stock",
    question: "Le système peut-il bloquer une vente si le stock disponible est insuffisant ?",
    answer:
      "Oui. Lorsque la règle de stock stricte est activée, Pharmapp bloque la vente si la quantité demandée dépasse le stock reconnu par le système. Cela permet de limiter les erreurs et d'imposer une meilleure discipline de saisie.",
  },
  {
    category: "Sécurité",
    question: "Qui peut accéder aux données de ma pharmacie ?",
    answer:
      "L'accès dépend des droits configurés dans votre espace et des profils créés par votre organisation. Vous restez responsable de la confidentialité de vos identifiants, de la gestion des accès internes et des actions effectuées depuis vos comptes utilisateurs.",
  },
  {
    category: "Contrôle",
    question: "Peut-on limiter la modification des ventes déjà effectuées ?",
    answer:
      "Oui. Les paramètres permettent d'encadrer la modification d'une vente selon la politique choisie par l'entreprise. Vous pouvez ainsi laisser une marge d'action plus large, réserver certains cas au vendeur avec des conditions précises, ou limiter cette faculté à l'administrateur.",
  },
  {
    category: "Accès",
    question: "Peut-on empêcher un vendeur de se connecter depuis un navigateur web ?",
    answer:
      "Oui. Les paramètres de l'application permettent de définir si les utilisateurs ayant le rôle vendeur peuvent accéder au système depuis un navigateur, ou uniquement depuis le terminal prévu pour l'exploitation.",
  },
  {
    category: "Rapports",
    question: "Quels rapports ou indicateurs peut-on récupérer dans Pharmapp ?",
    answer:
      "Pharmapp permet notamment de télécharger des rapports en JSON ou en PDF et d'exploiter des indicateurs comme les ventes par jour, les ventes par heure, les produits les plus vendus, les écarts de valeur et certaines progressions de produits dans le temps.",
  },
  {
    category: "Facturation",
    question: "L'impression de facture est-elle déjà disponible ?",
    answer:
      "Oui. L'impression de facture fait déjà partie du fonctionnement prévu de la solution. Selon l'organisation choisie par votre pharmacie, elle peut aussi s'inscrire dans les règles de contrôle des ventes et de modification après émission.",
  },
  {
    category: "Caisse",
    question: "La caisse permet-elle seulement de voir un total global ?",
    answer:
      "Non. La caisse peut aussi détailler les ventes du jour, les dépôts, les retraits, le montant attendu par vendeur et, pour un administrateur, une vue plus globale des mouvements enregistrés.",
  },
  {
    category: "Résiliation",
    question: "Puis-je demander l'arrêt du service ?",
    answer:
      "Oui. La demande peut être formulée selon les modalités contractuelles applicables à votre formule. La résiliation n'efface pas automatiquement les obligations nées avant sa prise d'effet, notamment celles liées aux paiements déjà dus ou aux usages non conformes.",
  },
  {
    category: "Support",
    question: "Comment contacter Pharmapp pour une question ou un incident ?",
    answer:
      "Vous pouvez utiliser les coordonnées ou canaux de contact communiqués lors de votre inscription, de votre souscription ou via le portail. Pour les demandes liées aux données personnelles ou aux obligations contractuelles, il est recommandé d'écrire par un canal traçable.",
  },
];
